import router from './commons/Router.js';
import './commons/facebook.js';
import analytics from "./commons/analytics.js";
import './commons/Users.js';
import './commons/playersManager.js';
import './commons/blocco_player.js';
import './commons/LiveSongs.js';
import './commons/players_util.js';
import './commons/player_bottom.js';
import './commons/socialShare.js';
import './commons/preferiti.js';
import './commons/search.js';
import './commons/pageViews.js';
import './commons/commonsListeners.js';
import './commons/post_gallery.js';

router.init();

// $(document).ready(function () {
//     analytics.init();
// });


